import { Form, Card, Badge } from 'react-bootstrap'

interface PromptConfigSectionProps {
  isOrgScope: boolean
  promptHeader: string
  onPromptHeaderChange: (value: string) => void
  promptBody: string
  onPromptBodyChange: (value: string) => void
  promptFooter: string
  onPromptFooterChange: (value: string) => void
  shareContactInfo: boolean | null
  onShareContactInfoChange: (value: boolean | null) => void
  shareQuotes: boolean | null
  onShareQuotesChange: (value: boolean | null) => void
  sharePolicies: boolean | null
  onSharePoliciesChange: (value: boolean | null) => void
  shareLeads: boolean | null
  onShareLeadsChange: (value: boolean | null) => void
  shareConsentStatus: boolean | null
  onShareConsentStatusChange: (value: boolean | null) => void
}

export const PromptConfigSection = ({
  isOrgScope,
  promptHeader,
  onPromptHeaderChange,
  promptBody,
  onPromptBodyChange,
  promptFooter,
  onPromptFooterChange,
  shareContactInfo,
  onShareContactInfoChange,
  shareQuotes,
  onShareQuotesChange,
  sharePolicies,
  onSharePoliciesChange,
  shareLeads,
  onShareLeadsChange,
  shareConsentStatus,
  onShareConsentStatusChange,
}: PromptConfigSectionProps) => {
  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Header className="bg-light border-bottom">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="mb-0">
            <span className="me-2">📝</span>
            Prompt de IA Conversacional
          </h5>
          <Badge bg="secondary">{isOrgScope ? 'Organización' : 'Personalización'}</Badge>
        </div>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            Encabezado (consideraciones iniciales)
            {!isOrgScope && <span className="text-muted"> — solo editable a nivel organización</span>}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={promptHeader}
            onChange={(e) => onPromptHeaderChange(e.target.value)}
            disabled={!isOrgScope}
            placeholder="Ej: Eres un asesor de seguros. Responde de forma amable, profesional y concisa."
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Cuerpo (personalizaciones de este nivel)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={promptBody}
            onChange={(e) => onPromptBodyChange(e.target.value)}
            placeholder="Instrucciones adicionales para este nivel. Se agregan al del resto de la herencia, nunca lo reemplazan."
          />
          <Form.Text className="text-muted d-block mt-2">
            El prompt final combina el cuerpo de organización, grupo y agente — este texto se
            agrega, no reemplaza lo que ya definió la organización.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            Pie (restricciones y limitaciones)
            {!isOrgScope && <span className="text-muted"> — solo editable a nivel organización</span>}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={promptFooter}
            onChange={(e) => onPromptFooterChange(e.target.value)}
            disabled={!isOrgScope}
            placeholder="Ej: No inventes información que no tengas disponible."
          />
        </Form.Group>

        <hr />

        <Form.Label className="mb-2">Información del cliente a compartir con el LLM</Form.Label>
        <Form.Text className="text-muted d-block mb-2">
          Solo se comparte información referencial (nunca datos sensibles como SSN, montos o
          documentos).
        </Form.Text>

        <Form.Check
          type="checkbox"
          id="share-contact-info"
          label="Contacto (nombre y estado) — default"
          checked={!!shareContactInfo}
          onChange={(e) => onShareContactInfoChange(e.target.checked)}
          className="mb-2"
        />
        <Form.Check
          type="checkbox"
          id="share-quotes"
          label="Cotizaciones (estado, sin el detalle)"
          checked={!!shareQuotes}
          onChange={(e) => onShareQuotesChange(e.target.checked)}
          className="mb-2"
        />
        <Form.Check
          type="checkbox"
          id="share-policies"
          label="Pólizas (tipo y estado, sin prima ni IDs)"
          checked={!!sharePolicies}
          onChange={(e) => onSharePoliciesChange(e.target.checked)}
          className="mb-2"
        />
        <Form.Check
          type="checkbox"
          id="share-leads"
          label="Leads (etapa e intención)"
          checked={!!shareLeads}
          onChange={(e) => onShareLeadsChange(e.target.checked)}
          className="mb-2"
        />
        <Form.Check
          type="checkbox"
          id="share-consent-status"
          label="Estado de consentimiento (firmado o no, sin el documento)"
          checked={!!shareConsentStatus}
          onChange={(e) => onShareConsentStatusChange(e.target.checked)}
          className="mb-2"
        />
      </Card.Body>
    </Card>
  )
}
